import { render, staticRenderFns } from "./FaceTextures.vue?vue&type=template&id=62522e80&scoped=true&"
import script from "./FaceTextures.vue?vue&type=script&lang=ts&"
export * from "./FaceTextures.vue?vue&type=script&lang=ts&"
import style0 from "./FaceTextures.vue?vue&type=style&index=0&id=62522e80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62522e80",
  null
  
)

export default component.exports